export default {
  step: {
    en: '{step} of {count}',
  },
}
